import "./App.css";
import Login from "./components/login/login";
import Cookies from "universal-cookie";

function App() {
  return (
    <div>
      <Login />
    </div>
  );
}

export default App;
